import React from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import ChangeAdminForm from '../../../components/siteadmin/ChangeAdminForm';

import s from './ChangeAdmin.css';

const ChangeAdmin = (props) => {
  const { title } = props;
  return <ChangeAdminForm title={title} />
}

ChangeAdmin.propTypes = {
  title: PropTypes.string.isRequired,
};

export default withStyles(s)(ChangeAdmin); 